<template>
  <div class="date-time-component">
    <div class="mask" :style="{ background: maskColor }" @click="dateClick">
      <span :class="{ placeholder: text === 'None' }">{{ text }}</span>
      <i
        v-if="value && clearAble"
        @click.stop="clear()"
        style="margin-left: 8px; position: relative; top: 0.5px"
        class="el-icon-error del-icon"
      ></i>
    </div>
    <el-date-picker
      ref="datePicker"
      style="width: 100px !important"
      v-model="value"
      :picker-options="pickerOptions"
      :type="type"
      :value-format="valueFormat"
      :format="format"
      @focus="focus"
    ></el-date-picker>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope lang="less">
@import "../../../assets/style/theme.less";

.date-time-component {
  position: relative;

  .mask {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    position: absolute;
    text-align: right;
    z-index: 1;
    background: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    &.readonly {
      opacity: 0.3;
    }
    .placeholder {
      color: #cbced5;
    }
    .del-icon {
      font-size: 13px;
      margin-left: 8px;
      position: relative;
      top: -1px;
      cursor: pointer;

      &:active,
      &:hover {
        opacity: 0.7;
      }
    }
  }
}
</style>
<script>
import moment from "moment-timezone";

export default {
  name: "DateTimeComponent",
  model: {
    // 实现v-model
    prop: "val",
    event: "updateVal",
  },
  props: {
    maskColor: { type: String, default: "#FFF" },
    val: {
      required: true,
    },
    pickerOptions: {
      default: () => {
        return {};
      },
    },
    readonly: {
      // 是否只读
      type: Boolean,
      default: false,
    },
    clearAble: {
      // 是否有清楚按钮
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "datetime",
    },
  },
  methods: {
    dateClick() {
      if (!this.readonly) {
        this.$refs.datePicker.focus();
      }
      this.$emit("itemClick");
    },
    /**
     * 焦点事件
     */
    focus(time) {
      this.$emit("focus", time);
    },
    /**
     *  清空时间
     */
    clear() {
      this.value = "";
    },
  },
  data() {
    return {
      value: this.val,
    };
  },
  computed: {
    valueFormat() {
      if (this.type === "datetime") {
        return "yyyy-MM-dd HH:mm:ss";
      } else if (this.type === "date") {
        return "yyyy-MM-dd";
      }
    },
    format() {
      if (this.type === "datetime") {
        return "yyyy-MM-dd HH:mm";
      } else if (this.type === "date") {
        return "yyyy-MM-dd";
      }
    },
    text() {
      if (this.val) {
        if (this.type === "datetime") {
          return moment(this.val).format("MMM DD, YYYY HH:mm");
        } else if (this.type === "date") {
          return moment(this.val).format("MMM DD, YYYY");
        }
      } else {
        return "None";
      }
    },
  },
  watch: {
    /**
     * 监听文本值变化，变化时触发updateVal事件，实现双向绑定
     */
    value() {
      this.$emit("updateVal", this.value);
    },
    /**
     * 当props val变化时改变data中value值，从而实现双向绑定
     */
    val(val) {
      this.value = val;
    },
  },
};
</script>
